import type { CreateSetup } from '@hvf/contracts'

export const TECHNICAL_FIELDS_SHORT: Array<keyof CreateSetup> = [
	'low_1_price',
	'low_1_time',
	'high_1_price',
	'high_1_time',
	'low_2_price',
	'low_2_time',
	'high_2_price',
	'high_2_time',
	'low_3_price',
	'low_3_time',
	'high_3_price',
	'high_3_time',
]

export const TECHNICAL_FIELDS_LONG: Array<keyof CreateSetup> = [
	'high_1_price',
	'high_1_time',
	'low_1_price',
	'low_1_time',
	'high_2_price',
	'high_2_time',
	'low_2_price',
	'low_2_time',
	'high_3_price',
	'high_3_time',
	'low_3_price',
	'low_3_time',
]
